import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationAlertService } from '../notifications-alert/service/notifications-alert.service'; // Ajusta la ruta
import { NotificationsAlertComponent, ToastConfig, ToastPosition } from '../notifications-alert/notifications-alert.component'; // Ajusta la ruta
import { CommonModule } from '@angular/common';


type ToastsByPosition = {
  [key in ToastPosition]?: ToastConfig[];
};

@Component({
    selector: 'app-notifications-container',
    standalone: true,
    imports: [CommonModule, NotificationsAlertComponent],
    templateUrl: './notifications-container.component.html',
    styleUrl: './notifications-container.component.scss'
})
export class NotificationsContainerComponent {
  toastsByPosition$: Observable<ToastsByPosition>;
  positions: ToastPosition[] = ['top-left', 'top-center', 'top-right', 'bottom-left', 'bottom-center', 'bottom-right'];

  constructor(private notificationService: NotificationAlertService) {
    this.toastsByPosition$ = this.notificationService.toasts$.pipe(
      map(toasts => {

        const grouped: ToastsByPosition = {};
        for (const toast of toasts) {
          const pos = toast.position || 'top-right';
          if (!grouped[pos]) {
            grouped[pos] = [];
          }
          grouped[pos]!.push(toast);
        }
        return grouped;
      })
    );
  }

  onClose(id: number): void {
    this.notificationService.remove(id);
  }

  trackById(index: number, item: ToastConfig): number {
    return item.id;
  }
}